export const liveColorSubcats = [
    'tshirts',
    'tanks',
    'hoodies',
    'sweatshirts',
    'pillows',
    'accessories'
];
